import { Component } from 'solid-js'

export const Sprite: Component<{ id: string }> = P => {
    return <use href={'/public/s.svg#' + P.id} />
}
